module.exports = __webpack_public_path__ + "img/拍照按钮.13d2b4e5.png";